var Component = require("!../../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../vue-loader/lib/selector?type=script&index=0!./rtDetailItem.vue"),
  /* template */
  require("!!../../../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-564cd157\"}!../../../../../vue-loader/lib/selector?type=template&index=0!./rtDetailItem.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-xpc/src/components/business/detail/rtDetailItem.vue
// module id = 1373
// module chunks = 91